import React, { useState, useEffect } from 'react';
import axios from 'axios';

function Contact() {
  const [loading, setLoading] = useState(true);
  const [contactData, setContactData] = useState(null);
  const server_url = process.env.REACT_APP_API_URI;
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [selected, setSelected] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const options = [
    'Business Owner/Representative',
    'Media and Public Relations',
    'Consumer',
    'Other',
  ];

  const fetchContact = async () => {
    try {
      const response = await axios.get(
        `${server_url}/content/get-content/67ced8bcee43f4fe4036dd54`,
      );

      if (response.data && response.data.data) {
        setContactData(response.data.data);
      } else {
        setContactData(null);
      }
    } catch (error) {
      console.error('Error fetching contact data:', error);
      setContactData(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchContact();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    const formData = Object.fromEntries(new FormData(e.target));
    try {
      const response = await axios.post(
        `${server_url}/contactUs/add`,
        formData,
      );
      console.log('Response:', response.data);
      setSuccessMessage('Form submitted successfully!');
      e.target.reset();
    } catch (error) {
      console.error('Error submitting form:', error);
      alert('Failed to submit the form. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <div class="min-h-[calc(100vh-300px)] max-w-screen-xl mx-auto mt-6 mb-4">
        <h1 className="text-4xl font-bold text-white text-center mb-8">
          {contactData?.mainTitle || 'Contact Us'}
        </h1>

        {/* data part */}
        <div className="bg-white/10 backdrop-blur-md rounded-3xl shadow-xl p-6 mx-4 mb-5 ">
          {loading && (
            <p className="text-white text-center mb-6">
              Loading contact information...
            </p>
          )}

          {!loading && contactData?.sections?.length > 0 && (
            <div className="text-white  space-y-4">
              {contactData.sections.map((section) => (
                <div key={section._id}>
                  <h2 className="text-xl font-semibold text-center  text-secondary md:text-left mb-4 lg:mb-2">
                    {section.title}
                  </h2>
                  {section.contents.map((content) => (
                    <div
                      key={content._id}
                      dangerouslySetInnerHTML={{ __html: content.content }}
                      className="pl-4 space-y-2 list-disc [&>ul]:list-disc [&>ul]:pl-5"
                    />
                  ))}
                </div>
              ))}
            </div>
          )}
        </div>

        {/* form part */}
        <div className="bg-white/10 backdrop-blur-md rounded-3xl shadow-xl p-6 mx-4  ">
          {successMessage && (
            <p className="text-green-500 text-center text-lg mb-4">
              {successMessage}
            </p>
          )}
          <form
            onSubmit={handleSubmit}
            className="grid grid-cols-1 lg:grid-cols-2 gap-6"
          >
            <div>
              <label className="block text-white font-semibold mb-2">
                Name
              </label>
              <input
                type="text"
                name="name"
                required
                className="w-full px-4 py-3  rounded-xl bg-gray-900 text-white placeholder-gray-200 focus:outline-none focus:ring-2 focus:ring-secondary"
                placeholder="Your full name"
              />
            </div>

            <div>
              <label className="block text-white font-semibold mb-2">
                Email
              </label>
              <input
                type="email"
                name="email"
                required
                className="w-full px-4 py-3  rounded-xl bg-gray-900 text-white placeholder-gray-200 focus:outline-none focus:ring-2 focus:ring-secondary"
                placeholder="example@email.com"
              />
            </div>

            <div>
              <div className="relative w-full ">
                <label className="block text-white font-semibold mb-2">
                  Who are You?
                </label>
                <div
                  onClick={() => setIsOpen(!isOpen)}
                  className="cursor-pointer w-full px-4 py-3 rounded-xl bg-gray-900 text-white flex justify-between items-center"
                >
                  {selected || 'Select an option'}
                  <span className="ml-2">&#9662;</span>
                  <input type="hidden" name="userType" value={selected} />
                </div>
                {isOpen && (
                  <div className="absolute z-10 mt-1 w-full rounded-xl bg-gray-900 shadow-md text-secondary">
                    {options.map((option) => (
                      <div
                        key={option}
                        onClick={() => {
                          setSelected(option);
                          setIsOpen(false);
                        }}
                        className="px-4 py-2 hover:bg-white/10 hover:text-secondary cursor-pointer rounded-xl"
                      >
                        {option}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>

            <div className="lg:col-span-2">
              <label className="block text-white font-semibold mb-2">
                Message
              </label>
              <textarea
                name="message"
                rows="4"
                required
                className="w-full px-4 py-3  rounded-xl bg-gray-900 text-white placeholder-gray-200 focus:outline-none focus:ring-2 focus:ring-secondary"
                placeholder="Your message..."
              ></textarea>
            </div>

            <div className="lg:col-span-2 text-center">
              <button
                type="submit"
                disabled={isSubmitting}
                className={`bg-secondary hover:bg-primary hover:text-secondary text-primary font-bold py-3 px-8 rounded-full transition duration-300 ${isSubmitting ? 'opacity-50 cursor-not-allowed' : ''}`}
              >
                {isSubmitting ? 'Sending...' : 'Send Message'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}

export default Contact;
